import { render, staticRenderFns } from "./SupportIssue.vue?vue&type=template&id=3437c3e2&"
import script from "./SupportIssue.vue?vue&type=script&lang=js&"
export * from "./SupportIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports